import axios from 'axios';

const protocole = window.location.protocol;
const host_client = window.location.hostname.split('.')[0];

const envServer = (process.env.REACT_APP_SERVER || '').trim().replace(/\/$/, '');

let apiBase = '';

if (envServer) {
  apiBase = envServer;
} else if (host_client === 'auna') {
  apiBase = `${protocole}//auna.auna.api.dev.polysign.pe`;
} else if (window.location.hostname.indexOf('.localhost') >= 0) {
  apiBase = `${protocole}//${host_client}.api.dev.localhost:8000`;
} else if (window.location.hostname.indexOf('.dev.') >= 0) {
  apiBase = `${protocole}//${host_client}.api.dev.polysign.pe`;
} else if (window.location.hostname.indexOf('.app.') >= 0) {
  apiBase = `${protocole}//${host_client}.api.app.polysign.pe`;
} else {
  apiBase = `${protocole}//${host_client}.api.polysign.pe`;
}

const applyAuthHeader = config => {
  const token = localStorage.getItem('accessToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
};

axios.defaults.baseURL = apiBase;
axios.defaults.headers.post['Accept'] = '*/*';
axios.defaults.headers.post['Content-Type'] = 'application/json';

const initialToken = localStorage.getItem('accessToken');
if (initialToken) {
  axios.defaults.headers.common['Authorization'] = `Bearer ${initialToken}`;
}

axios.interceptors.request.use(
  config => applyAuthHeader(config),
  error => Promise.reject(error),
);

// Endpoints propios de autenticación: un 401 aquí es "credenciales inválidas"
// o "refresh token inválido", nunca "access token expirado" — no deben
// disparar el flujo de refresh (si no, un 401 de /api/token/refresh/
// reintentaría el refresh contra sí mismo en bucle infinito).
const AUTH_ENDPOINTS = ['/api/token/', '/api/token/refresh/'];
const isAuthEndpoint = url => AUTH_ENDPOINTS.some(path => (url || '').includes(path));

axios.interceptors.response.use(
  response => response,
  error => {
    const originalRequest = error.config;
    const refreshToken = localStorage.getItem('refreshToken');
    if (
      refreshToken &&
      error.response?.status === 401 &&
      originalRequest &&
      !originalRequest._retry &&
      !isAuthEndpoint(originalRequest.url)
    ) {
      originalRequest._retry = true;
      return axios
        .post(`${apiBase}/api/token/refresh/`, { refresh: refreshToken })
        .then(res => {
          if (res.status === 200) {
            localStorage.setItem('accessToken', res.data.access);
            applyAuthHeader(originalRequest);
            return axios(originalRequest);
          }
          return Promise.reject(error);
        })
        .catch(refreshError => {
          // El refresh token también es inválido/expiró: limpiar sesión para
          // no arrastrar un refreshToken corrupto a futuros intentos de login.
          localStorage.removeItem('accessToken');
          localStorage.removeItem('refreshToken');
          delete axios.defaults.headers.common.Authorization;
          return Promise.reject(error);
        });
    }
    return Promise.reject(error);
  },
);

// ----------------------------------------------------------------------

const axiosInstance = axios.create({
  baseURL: apiBase,
});

axiosInstance.interceptors.request.use(
  config => applyAuthHeader(config),
  error => Promise.reject(error),
);

axiosInstance.interceptors.response.use(
  response => response,
  error => Promise.reject(error),
);

export { apiBase };
export default axiosInstance;